import { esDiningRoomPalettes } from "../../../../Posts/05-tematicas/02-sala-de-comedor/diningRoomPalettes.js";
import * as React from 'react';
export default {
  esDiningRoomPalettes,
  React
};